<template>
    <base-modal v-bind:modalTitle="'Add Slot'" v-on:save="save()" v-on:close="close()">
        <FormulateForm v-model="model">
            <FormulateInput type="time"
                            name="start_time"
                            label="Start Time"
                            validation="required"
                            :validation-messages="{required: 'Start Time is required'}"
                            @validation="checkValidation" />
        <FormulateInput type="time"
                        name="end_time"
                        label="End Time"
                        validation="required|afterStart"
                        :validation-rules="{afterStart: afterStart}"
                        :validation-messages="{
                            afterStart: 'End Time must be after Start Time',
                            required: 'End Time is required'}"
                        @validation="checkValidation" />
    </FormulateForm>
</base-modal>
</template>

<script>
 // Load the full build. 
 var _ = require('lodash');

 import BaseModal from 'components/modals/BaseModal';

 export default {
   components: {
     BaseModal
   },
   props: {
       timeSlot: null
   },
   
   data () {
     return {
         validation: {},
         isValid: false,
         model: {
             id: null,
             start_time: null,
             end_time: null
         }
     };
   },
     computed: {
     },
   created () {
       if (this.timeSlot) {
           this.model = _.clone(this.timeSlot, true);
           this.isValid = true;
       }

       this.model.key = this.model.id ? this.model.id : this.randomId();
   },
   methods: {
     randomId() {
       var r1 = ("0000000" + (Math.random() * 10000000).toFixed()).substr(-7);
       var r2 = ("0000000" + (Math.random() * 10000000).toFixed()).substr(-7);
       return "temp_" + r1 + "_" + r2;
     },
       afterStart(context) {
           try {
               let end_time = new Date("1970-01-01 " + context.value);
               let start_time = new Date("1970-01-01 " + context.getFormValues().start_time);
               return end_time > start_time;
           } catch(e) {
               return false;
           }
       },
     close() {
       this.$emit('close');
     },
       checkValidation(ev) {
           this.validation[ev.name] = ev;
           let fieldValidations = Object.values(this.validation);
           let res = fieldValidations.length > 0;
           fieldValidations.forEach((field) =>  {
               res = res && !field.hasErrors;
           });
           this.isValid = res;

       },
       save() {
           if (this.isValid) {
             this.$emit('save', this.model);
         }
     }
   }

 }
</script>


<style>
.multiple-choices > div.formulate-input-group {
  height: 200px;
  max-height: 200px;
  overflow: auto;
  overscroll-behavior: contain;
  border: 1px solid #ddd;
  padding: 10px 10px;
  border-radius: 4px 4px 4px 4px;
}
</style>



// WEBPACK FOOTER //
// AgentScheduleSlotModal.vue?34ab84a4